<template>
  <div class="bg-white rounded-2xl shadow-lg p-5 mx-auto" >
    <!-- Top info -->
    <div class="flex justify-between mb-1">
      <div>
        <div class="text-gray-700 font-semibold md:text-base">Compenso</div>
        <div class="text-gray-400 text-sm mt-1 text-left md:text-base">Date</div>
        <div class="text-gray-400 text-sm mt-1 text-left md:text-base">Luogo</div>
      </div>
      <div class="text-right">
        <div class="text-gray-800 font-bold md:text-xl">{{ pay }}</div>
        <div class="text-sm text-gray-500 mt-1 md:text-base">{{ date }}</div>
        <div class="text-sm text-gray-500 mt-1 md:text-base">{{ place }}</div>
      </div>
    </div>
    <!-- Divider and requisiti label -->
    <div class="flex items-center my-3">
      <div class="flex-1 h-px bg-gray-200"></div>
      <div class="px-3 text-gray-600 text-sm font-semibold md:text-base">requisiti</div>
      <div class="flex-1 h-px bg-gray-200"></div>
    </div>
    <!-- Requirements table -->
    <div>
      <div v-for="(value, label) in requirements" :key="label" class="flex justify-between mb-1">
        <div class="text-gray-400 text-sm md:text-base">{{ label }}</div>
        <div class="text-gray-800 text-sm font-medium text-right md:text-base">{{ value }}</div>
      </div>
    </div>
    <!-- Region (bottom) -->
    <div v-if="region" class="mt-6 pt-4 border-t border-gray-100 flex justify-between items-center">
      <div class="text-gray-400 text-sm md:text-base">Regione</div>
      <div class="text-gray-800 text-sm font-medium text-right md:text-base">{{ region }}</div>
    </div>
  </div>
</template>

<script>
export default {
  name: "CuCastingSpecsCard",
  props: {
    pay: { type: String, required: true },
    date: { type: String, required: true },
    place: { type: String, required: true },
    requirements: { type: Object, required: true },
    region: { type: String, required: false }
  }
}
</script>
